@if (loading) {
  <div class="spinner">
    <p-progressSpinner animationDuration="2s" strokeWidth="4">
    </p-progressSpinner>
  </div>
}
@if (!loading) {
  <div class="container">
    <a style="color: inherit; text-decoration: none">
      <div class="header" style="display: flex">
        {{ machineName }}
        <div style="margin-left: auto; cursor: pointer" (click)="goBack()">
          <img
            src="assets/icons/24px_close.svg"
            style="margin-right: 10px; cursor: pointer"
          />
        </div>
      </div>
    </a>
    <div class="list-container">
      @if (notifications.length === 0) {
        <div class="no-notifications">
          No active notifications or recommended actions
        </div>
      }
      @for (notification of notifications; track notification) {
        <div class="list-item" (click)="openNotification(notification)">
          @if (notification.machineName) {
            <div class="notification-machine-name">
              {{ notification.machineName }}
            </div>
          }
          <div style="display: flex">
            <div style="display: flex" class="warning-chip">
              <img
                src="assets/icons/16px_warning-sign.svg"
                style="margin-right: 10px"
              />
              <div style="color: #692c01">Attention</div>
              <div style="font-weight: 400; margin-left: 16px; width: 200px">
                {{ notification.timestamp | timeAgo }}
              </div>
            </div>
          </div>
          <div class="notification-title">
            {{ notification.title }}
          </div>
        </div>
      }
    </div>
  </div>
}
